import get from 'lodash/get';
import { combineReducers } from 'redux';
import {
  CLEAR_PAYING_OBJECT,
  CLOSE_CANCEL_PAYMENT_MODAL,
  CREATE_PAYMENT_CARD,
  FETCH_PAYMENT_CARD,
  OPEN_CANCEL_PAYMENT_MODAL,
  PAYMENT_FAILED,
  RESET_PAYMENT_CARD,
  SET_PAYING_OBJECT,
} from './constants';
import {
  SALE_CARD_CHARGE,
  SALE_READERLESS_POS_CHARGE,
} from '../../register/payment/constants';


const payingObject = (state = null, action) => {
  switch (action.type) {
    case SET_PAYING_OBJECT:
      return action.payload || null;
    case CLEAR_PAYING_OBJECT:
      return null;
    default:
      return state;
  }
};

const price = (state = null, action) => {
  switch (action.type) {
    case SET_PAYING_OBJECT:
      return get(action, 'payload.price', 0);
    default:
      return state;
  }
};

const kind = (state = null, action) => {
  switch (action.type) {
    case SET_PAYING_OBJECT:
      return get(action, 'payload.kind', '');
    default:
      return state;
  }
};

const type = (state = null, action) => {
  switch (action.type) {
    case SET_PAYING_OBJECT:
      return get(action, 'payload.type', '');
    default:
      return state;
  }
};

const loading = (state = false, action) => {
  switch (action.type) {
    case SALE_CARD_CHARGE:
    case SALE_READERLESS_POS_CHARGE:
    case PAYMENT_FAILED:
      return false;
    default:
      return state;
  }
};

const paymentCard = (state = {}, action) => {
  switch (action.type) {
    case FETCH_PAYMENT_CARD:
    case CREATE_PAYMENT_CARD:
      return action.payload || {};

    case RESET_PAYMENT_CARD:
      return {};

    default:
      return state;
  }
};

const cancelPaymentModal = (state = false, action) => {
  switch (action.type) {
    case PAYMENT_FAILED:
    case CLOSE_CANCEL_PAYMENT_MODAL:
      return false;
    case OPEN_CANCEL_PAYMENT_MODAL:
      return true;
    default:
      return state;
  }
};

export default combineReducers({
  payingObject,
  price,
  kind,
  loading,
  paymentCard,
  type,
  cancelPaymentModal,
});
